import { render, staticRenderFns } from "./EditCoupon.vue?vue&type=template&id=523f479f&scoped=true&"
import script from "./EditCoupon.vue?vue&type=script&lang=js&"
export * from "./EditCoupon.vue?vue&type=script&lang=js&"
import style0 from "./EditCoupon.vue?vue&type=style&index=0&id=523f479f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f479f",
  null
  
)

export default component.exports